// external libs
import { ofType } from 'redux-observable'
import { from, of } from 'rxjs'
import { switchMap, catchError } from 'rxjs/operators'

import SuriApi from '../../Services/SuriApi'

// redux
import DiscountsActions, { DiscountsTypes } from '../Redux/DiscountsRedux'
import GeneralActions, { ERROR_TYPES } from '../Redux/GeneralRedux'
import InputHelpsActions from '../Redux/InputHelpsRedux'

const ContentEpic = [
  action$ => (
    action$.pipe(
      ofType(DiscountsTypes.GET_DISCOUNT_RESOURCES_REQUEST),
      switchMap(action => (
        from(SuriApi.getDiscountResources(action.product)).pipe(
          switchMap(response => of(DiscountsActions.getDiscountResourcesRequestSuccess(response.data))),
          catchError(e => of(GeneralActions.onChangeRequestFailure(e, ERROR_TYPES.CRITICAL)))
        )
      ))
    )
  ),
  action$ => (
    action$.pipe(
      ofType(DiscountsTypes.GET_DISCOUNT_CONTENT_REQUEST),
      switchMap(action => (
        from(SuriApi.getDiscountContent(action.product)).pipe(
          switchMap((response) => {
            const result = [DiscountsActions.getDiscountContentRequestSuccess(response.data.data)]

            const { inputHelps } = response.data.data
            if (inputHelps) {
              result.push(InputHelpsActions.discountsInputHelpsMerge(inputHelps))
            }

            return from(result)
          }),
          catchError(e => of(GeneralActions.onChangeRequestFailure(e, ERROR_TYPES.CRITICAL)))
        )
      ))
    )
  )
]

export default ContentEpic
